import React, { useState, useEffect } from "react";
import { Link, NavLink as RouterNavLink } from "react-router-dom";
import {
    Collapse,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    NavbarBrand,
    Navbar,
    NavItem,
    NavLink,
    Nav,
    Container,
    UncontrolledTooltip,
} from "reactstrap";
import logo from "assets/img/logo.png";
import axios from "axios";
import "./navbar.css";

function ExamplesNavbar() {
    const [navbarColor, setNavbarColor] = useState("navbar-info");
    const [collapseOpen, setCollapseOpen] = useState(false);
    const [programGroups, setProgramGroups] = useState([]);
    const [isProgramOpen, setIsProgramOpen] = useState(false);
    const [isCareerOpen, setIsCareerOpen] = useState(false);
    const [isDevelopmentOpen, setIsDevelopmentOpen] = useState(false);
    const [dropdownStates, setDropdownStates] = useState({});
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const updateNavbarColor = () => {
            if (document.documentElement.scrollTop > 399 || document.body.scrollTop > 399) {
                setNavbarColor("");
            } else {
                setNavbarColor("navbar-info");
            }
        };

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("scroll", updateNavbarColor);
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("scroll", updateNavbarColor);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/program/readProgram`
                );
                setProgramGroups(response.data);
            } catch (error) {
                console.error("Error fetching program groups:", error);
            }
        };

        fetchData();
    }, []);

    const handleDropdownToggle = (menuKey) => {
        setDropdownStates((prevState) => ({
            ...prevState,
            [menuKey]: !prevState[menuKey],
        }));
    };

    const handleMouseEnter = (menuKey) => {
        if (!isMobile) {
            setDropdownStates((prevState) => ({
                ...prevState,
                [menuKey]: true,
            }));
        }
    };

    const handleMouseLeave = (menuKey) => {
        if (!isMobile) {
            setDropdownStates((prevState) => ({
                ...prevState,
                [menuKey]: false,
            }));
        }
    };

    const dropdownMarginStyle = (defaultMargin) => ({
        position: "absolute",
        left: "100%",
        marginTop: isMobile ? "0px" : defaultMargin,
    });

    return (
        <>
            {collapseOpen && (
                <div
                    id="bodyClick"
                    onClick={() => {
                        document.documentElement.classList.toggle("nav-open");
                        setCollapseOpen(false);
                    }}
                />
            )}
            <Navbar
                className={`fixed-top ${navbarColor}`}
                color="info"
                expand="lg"
                style={{
                    backgroundImage: "url(" + require("assets/img/Navbar/62620.jpg") + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <Container>
                    <div className="navbar-translate">
                        <NavbarBrand href="/" id="navbar-brand">
                            <img
                                src={logo}
                                alt="logo"
                                style={{ width: "100px", height: "auto", maxWidth: "none" }}
                            />
                        </NavbarBrand>
                        <UncontrolledTooltip target="#navbar-brand">
                            Yayasan Karya Bakti United Tractors
                        </UncontrolledTooltip>
                        <button
                            className="navbar-toggler"
                            onClick={() => {
                                document.documentElement.classList.toggle("nav-open");
                                setCollapseOpen(!collapseOpen);
                            }}
                        >
                            <i
                                className="fas fa-bars"
                                style={{ fontSize: "28px", color: "#ffff" }}
                            ></i>
                        </button>
                    </div>
                    <Collapse className="justify-content-end" isOpen={collapseOpen} navbar>
                        <Nav navbar style={{ fontWeight: "bold" }}>
                            <NavItem>
                                <NavLink to="/" tag={RouterNavLink} style={{ color: "black" }}>
                                    BERANDA
                                </NavLink>
                            </NavItem>
                            <UncontrolledDropdown
                                nav
                                inNavbar
                                onMouseEnter={() => handleMouseEnter("tentang")}
                                onMouseLeave={() => handleMouseLeave("tentang")}
                                toggle={() => handleDropdownToggle("tentang")}
                                isOpen={dropdownStates["tentang"]}
                            >
                                <DropdownToggle nav caret style={{ color: "black" }}>
                                    TENTANG
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem to="/about" tag={RouterNavLink}>
                                        SEKILAS YAYASAN
                                    </DropdownItem>
                                    <DropdownItem to="/visi-misi" tag={RouterNavLink}>
                                        VISI & MISI
                                    </DropdownItem>
                                    <DropdownItem to="/budaya" tag={RouterNavLink}>
                                        BUDAYA & KARAKTER
                                    </DropdownItem>
                                    <DropdownItem to="/organisasi" tag={RouterNavLink}>
                                        STRUKTUR ORGANISASI
                                    </DropdownItem>
                                    <DropdownItem to="/jejak" tag={RouterNavLink}>
                                        MILESTONE
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <UncontrolledDropdown
                                nav
                                inNavbar
                                onMouseEnter={() => handleMouseEnter("unitOperasional")}
                                onMouseLeave={() => handleMouseLeave("unitOperasional")}
                                toggle={() => handleDropdownToggle("unitOperasional")}
                                isOpen={dropdownStates["unitOperasional"]}
                            >
                                <DropdownToggle nav caret style={{ color: "black" }}>
                                    UNIT OPERASIONAL
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem to="/utschool" tag={RouterNavLink}>
                                        UT SCHOOL
                                    </DropdownItem>
                                    <DropdownItem to="/klinik-pratama" tag={RouterNavLink}>
                                        KLINIK PRATAMA UT
                                    </DropdownItem>
                                    <DropdownItem to="/dcare" tag={RouterNavLink}>
                                        UT D'CARE
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <UncontrolledDropdown
                                nav
                                inNavbar
                                onMouseEnter={() => handleMouseEnter("tataKelola")}
                                onMouseLeave={() => handleMouseLeave("tataKelola")}
                                toggle={() => handleDropdownToggle("tataKelola")}
                                isOpen={dropdownStates["tataKelola"]}
                            >
                                <DropdownToggle nav caret style={{ color: "black" }}>
                                    TATA KELOLA
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem to="/pelaporan" tag={RouterNavLink}>
                                        SISTEM PELAPORAN PELANGGARAN
                                    </DropdownItem>
                                    <DropdownItem to="/kode-etik" tag={RouterNavLink}>
                                        KODE ETIK YKBUT
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <UncontrolledDropdown
                                nav
                                inNavbar
                                onMouseEnter={() => handleMouseEnter("keberlanjutan")}
                                onMouseLeave={() => handleMouseLeave("keberlanjutan")}
                                toggle={() => handleDropdownToggle("keberlanjutan")}
                                isOpen={dropdownStates["keberlanjutan"]}
                            >
                                <DropdownToggle nav caret style={{ color: "black" }}>
                                    KEBERLANJUTAN
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem to="/entitas" tag={RouterNavLink}>
                                        ENTITAS
                                    </DropdownItem>
                                    <DropdownItem
                                        onMouseEnter={() => setIsProgramOpen(true)}
                                        onMouseLeave={() => setIsProgramOpen(false)}
                                    >
                                        <span>
                                            KONTRIBUSI PUBLIK
                                            <span
                                                style={{
                                                    marginLeft: "5px",
                                                    border: "solid transparent",
                                                    borderWidth: "5px 5px 5px 0",
                                                    borderLeftColor: "black",
                                                }}
                                            >
                                                {" "}
                                                →
                                            </span>
                                        </span>
                                        {isProgramOpen && (
                                            <DropdownMenu style={dropdownMarginStyle("-58px")} end>
                                                {programGroups.map((program) => (
                                                    <DropdownItem
                                                        key={program.id_program}
                                                        to={`/program/${program.id_program}`}
                                                        tag={RouterNavLink}
                                                    >
                                                        {program.title}
                                                    </DropdownItem>
                                                ))}
                                            </DropdownMenu>
                                        )}
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <UncontrolledDropdown
                                nav
                                inNavbar
                                onMouseEnter={() => handleMouseEnter("sdm")}
                                onMouseLeave={() => handleMouseLeave("sdm")}
                                toggle={() => handleDropdownToggle("sdm")}
                                isOpen={dropdownStates["sdm"]}
                            >
                                <DropdownToggle nav caret style={{ color: "black" }}>
                                    SUMBER DAYA MANUSIA
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem
                                        onMouseEnter={() => setIsCareerOpen(true)}
                                        onMouseLeave={() => setIsCareerOpen(false)}
                                        isOpen={dropdownStates["karir"]}
                                    >
                                        <span>
                                            KARIR
                                            <span
                                                style={{
                                                    marginLeft: "5px",
                                                    border: "solid transparent",
                                                    borderWidth: "5px 5px 5px 0",
                                                    borderLeftColor: "black",
                                                }}
                                            >
                                                {" "}
                                                →
                                            </span>
                                        </span>
                                        {isCareerOpen && (
                                            <DropdownMenu style={dropdownMarginStyle("-100px")} end>
                                                <DropdownItem
                                                    to="/info-rekrutmen"
                                                    tag={RouterNavLink}
                                                >
                                                    INFO REKRUTMEN
                                                </DropdownItem>
                                                <DropdownItem to="/faqs" tag={RouterNavLink}>
                                                    TANYA JAWAB
                                                </DropdownItem>
                                            </DropdownMenu>
                                        )}
                                    </DropdownItem>
                                    <DropdownItem
                                        onMouseEnter={() => setIsDevelopmentOpen(true)}
                                        onMouseLeave={() => setIsDevelopmentOpen(false)}
                                    >
                                        <span>
                                            DEVELOPMENT
                                            <span
                                                style={{
                                                    marginLeft: "5px",
                                                    border: "solid transparent",
                                                    borderWidth: "5px 5px 5px 0",
                                                    borderLeftColor: "black",
                                                }}
                                            >
                                                {" "}
                                                →
                                            </span>
                                        </span>
                                        {isDevelopmentOpen && (
                                            <DropdownMenu style={dropdownMarginStyle("-58px")} end>
                                                <DropdownItem
                                                    href="https://ylcku.com/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    YKBUT LEARNING CENTER
                                                </DropdownItem>
                                            </DropdownMenu>
                                        )}
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <UncontrolledDropdown
                                nav
                                inNavbar
                                onMouseEnter={() => handleMouseEnter("ruangMedia")}
                                onMouseLeave={() => handleMouseLeave("ruangMedia")}
                                toggle={() => handleDropdownToggle("ruangMedia")}
                                isOpen={dropdownStates["ruangMedia"]}
                            >
                                <DropdownToggle nav caret style={{ color: "black" }}>
                                    RUANG MEDIA
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem to="/galeri" tag={RouterNavLink}>
                                        GALERI
                                    </DropdownItem>
                                    <DropdownItem
                                        href="https://magazine.ykbut.co.id/books"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        MAJALAH
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <NavItem>
                                <NavLink
                                    to="/hubungi"
                                    tag={RouterNavLink}
                                    style={{ color: "black" }}
                                >
                                    HUBUNGI
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href="https://www.youtube.com/@ykbutofficial"
                                    target="_blank"
                                    id="youtube-tooltip"
                                >
                                    <i className="fab fa-youtube" style={{ color: "black" }}></i>
                                    <p className="d-lg-none d-xl-none">Youtube</p>
                                </NavLink>
                                <UncontrolledTooltip target="#youtube-tooltip">
                                    Follow us on Youtube
                                </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href="https://www.instagram.com/ykbutofficial/"
                                    target="_blank"
                                    id="instagram-tooltip"
                                >
                                    <i className="fab fa-instagram" style={{ color: "black" }}></i>
                                    <p className="d-lg-none d-xl-none">Instagram</p>
                                </NavLink>
                                <UncontrolledTooltip target="#instagram-tooltip">
                                    Follow us on Instagram
                                </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href="https://www.facebook.com/ykbutofficial/"
                                    target="_blank"
                                    id="facebook-tooltip"
                                >
                                    <i className="fab fa-facebook" style={{ color: "black" }}></i>
                                    <p className="d-lg-none d-xl-none">Facebook</p>
                                </NavLink>
                                <UncontrolledTooltip target="#facebook-tooltip">
                                    Follow us on Facebook
                                </UncontrolledTooltip>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export default ExamplesNavbar;
